import React from "react";
import { useTranslation } from "react-i18next";
import { TennisBall, Snowflake, HandFist, Bicycle, Barbell, Waves, Mountains, X } from "@phosphor-icons/react";
import { disciplineCountByCategory } from "../lib/disciplines";

// key → icon component
const CATEGORY_ICONS = {
  racket: TennisBall,
  snow: Snowflake,
  combat: HandFist,
  bike: Bicycle,
  fitness: Barbell,
  water: Waves,
  outdoor: Mountains,
};

const CATEGORY_ORDER = ["racket", "snow", "combat", "bike", "fitness", "water", "outdoor"];

export default function DisciplineCategoriesStrip({ activeCategory, onSelectCategory }) {
  const { t } = useTranslation();

  return (
    <section className="border-b border-white/10 bg-gradient-to-b from-black to-[#0A0A0A]" data-testid="categories-strip">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div className="max-w-2xl">
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#E30613] font-bold">{t("categories.tag")}</div>
            <h2 className="font-display text-4xl sm:text-5xl uppercase font-black text-white mt-2 tracking-tight leading-[0.95]">
              {t("categories.title")}
            </h2>
            <p className="mt-4 text-sm text-zinc-400 leading-relaxed">{t("categories.subtitle")}</p>
          </div>
          {activeCategory && (
            <button
              onClick={() => onSelectCategory(null)}
              className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-zinc-400 hover:text-white border border-white/20 hover:border-[#E30613] px-4 py-2 transition-colors"
              data-testid="categories-clear"
            >
              <X size={12} weight="bold" /> {t("categories.clear")}
            </button>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
          {CATEGORY_ORDER.map((key) => {
            const Icon = CATEGORY_ICONS[key];
            const isActive = activeCategory === key;
            const count = disciplineCountByCategory(key);
            return (
              <button
                key={key}
                onClick={() => onSelectCategory(isActive ? null : key)}
                data-testid={`category-tile-${key}`}
                aria-pressed={isActive}
                className={`group relative overflow-hidden border p-5 text-left transition-all duration-200 ${
                  isActive
                    ? "border-[#E30613] bg-[#E30613]/10"
                    : "border-white/10 bg-[#0A0A0A] hover:border-[#E30613]/60 hover:bg-[#111]"
                }`}
              >
                <Icon
                  size={32}
                  weight="duotone"
                  className={`transition-colors ${isActive ? "text-[#E30613]" : "text-white group-hover:text-[#E30613]"}`}
                />
                <div className={`mt-4 font-display text-sm uppercase font-black tracking-tight ${isActive ? "text-white" : "text-white"}`}>
                  {t(`categories.${key}`)}
                </div>
                <div className="mt-1 text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold">
                  {t("categories.sports_count", { count })}
                </div>
                {isActive && (
                  <div className="absolute top-0 right-0 w-2 h-2 bg-[#E30613]" />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
